import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, Subscription } from "rxjs";
import { Ticket } from '../../../../spartacus/custom/cms-components/myaccount/custom-tickets/model/ticket.model';
import { CustomTicketsService } from '../../../../spartacus/custom/cms-components/myaccount/custom-tickets/services/custom-tickets.service';
import { CustomValidators } from '../../../../spartacus/custom/shared/utils/validators/custom-validators';
import { RecaptchaService } from '../../../../spartacus/features/recaptcha/recaptcha.service';
import { ICON_TYPE } from '../../../icons/icon.model';

@Component({
  selector: 'app-custom-contact-us',
  templateUrl: './custom-contact-us.component.html',
  styleUrls: ['./custom-contact-us.component.scss'],
  inputs: ['fullName', 'email', 'phone', 'message', 'termsCheck'],
  standalone: false
})
export class CustomContactUsComponent implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  @ViewChild('frm') frm: ElementRef;

  fullName: string;
  email: string;
  phone: string;
  message: string;
  termsCheck: boolean;

  protected submitted = new BehaviorSubject<boolean>(false);
  public submitted$ = this.submitted.asObservable();

  ticket: Ticket;
  iconTypes = ICON_TYPE;

  private category = 'CA_OTRAS';
  private subject = 'CONTACT';

  contactForm: UntypedFormGroup = this.formBuilder.group({
    fullName: ['', Validators.required],
    email: ['', [Validators.required, CustomValidators.emailValidator]],
    phone: ['', [Validators.required, CustomValidators.phoneValidator]],
    message: ['', [Validators.required, Validators.maxLength(5000)]],
    privacyPolicy: [false, Validators.requiredTrue],
    issueCategory: this.category,
    subject: this.subject,
    orderCode: '',
  });

  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected customTicketsService: CustomTicketsService,
    protected globalMessageService: GlobalMessageService,
    protected recaptchaService: RecaptchaService,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  submitForm(): void {
    this.switchToSubmitted();
    if (this.contactForm.valid) {
      this.recaptchaService.getToken().then(token => {
        if (token) {
          this.subscriptions.add(this.recaptchaService.validateRecaptchaToken(token).subscribe(response => {
            if (response?.status === 200) {
              this.ticket = this.contactForm.value;
              this.subscriptions.add(this.customTicketsService.addTicket(this.ticket).subscribe({
                next: () => {
                  this.showGlobalMessage('forms.contactUs.success',
                    GlobalMessageType.MSG_TYPE_CONFIRMATION);
                  this.frm.nativeElement.reset({
                    subject: this.subject,
                    issueCategory: this.category,
                  });
                },
              }));
            } else {
              this.recaptchaService.recaptchaError('forms.recaptcha.invalidToken');
            }
          }));
        } else {
          this.recaptchaService.recaptchaError('forms.recaptcha.invalidToken');
        }
      }).catch(() => this.recaptchaService.recaptchaError(null));
    } else {
      this.contactForm.markAllAsTouched();
    }
  }

  switchToSubmitted() {
    this.submitted.next(true);
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.submitted.next(false);
      }, 1500);
    }
  }

  protected showGlobalMessage(messageKey: string, messageType: GlobalMessageType): void {
    this.globalMessageService.add({ key: messageKey }, messageType);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
